import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { useAuth } from '../context/AuthContext';

const Header = ({ companyInfo, servicesInfo }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isAuthenticated } = useAuth();

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const handleServiceLinkClick = (svc, e) => {
        // Always navigate to the service page
        if (isMenuOpen) toggleMenu();
    };

    return (
        <header>
            {/* 导航菜单 */}
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container">
                    {/* Logo - visible on all screen sizes */}
                    <Link className="navbar-brand desktop-logo" to="/" onClick={() => isMenuOpen && toggleMenu()}>
                        <img src="/images/logo.png" alt="Logo" style={{ width: '150px', height: '50px' }} />
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleMenu}
                        aria-controls="circularMenu"
                        aria-expanded={isMenuOpen}
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="circularMenu">
                        <ul className={`nav header-nav circular-menu nav-left nav-size-large nav-spacing-xlarge ms-auto ${isMenuOpen ? 'show' : ''}`}>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-design-default">
                                <Link className="nav-top-link" to="/" onClick={toggleMenu}>主頁</Link>
                            </li>
                            {Array.isArray(servicesInfo) && servicesInfo.map((serviceType) => {
                                const topTo = (serviceType.introduction && serviceType.introduction.toURL) ? serviceType.introduction.toURL : `/${serviceType.id}`;
                                return (
                                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-design-default" key={serviceType.id}>
                                        <Link
                                            className="nav-top-link"
                                            to={topTo}
                                            onClick={(e) => handleServiceLinkClick(serviceType, e)}
                                        >
                                            {serviceType.label}
                                        </Link>
                                    </li>
                                );
                            })}
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-design-default">
                                <Link className="nav-top-link" to="/about" onClick={toggleMenu}>關於我們</Link>
                            </li>
                        </ul>
                        
                        <div className="auth-actions ms-lg-auto">
                            {!isAuthenticated && (
                                <Link
                                    className="btn btn-sm btn-outline-primary auth-btn"
                                    to={`/login`}
                                    onClick={() => isMenuOpen && toggleMenu()}
                                >
                                    登入
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;